export default __webpack_public_path__ + "static/media/profile.dc357c81.jpg";